export class Answer {

  public comment_feed_id: number;
  public answer: string;

  constructor() {
  }

  populate(data): Answer {
    this.comment_feed_id = data.comment_feed_id;
    this.answer = data.answer;
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/app/models/answer.ts